import React from 'react';

import { getFishingWaterUrl } from '../../../helpers/urls';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { ChevronDownIcon } from '../../Icons/ChevronDownIcon';
import { ChevronUpIcon } from '../../Icons/ChevronUpIcon';
import { Text } from '../../Text/Text';
import { ISEOWaterObjWithName } from '../../../constants/fishingWaters/constants';

interface IProps {
  topSearchedWaters: ISEOWaterObjWithName[];
}

export const SEOWaterLink = ({ topSearchedWaters }: IProps) => {
  const pillsShown = 5;

  return (
    <div className="relative flex flex-wrap gap-2 sm:pr-6">
      <input type="checkbox" id="SEOWaterLink-checkbox" className="peer hidden" />
      {topSearchedWaters.map((water, index) => {
        const isHidden = index > pillsShown;
        const { fishingWaterId, fishingWaterName, seoName, seoRegion } = water;
        const waterName = `${seoName ?? fishingWaterName}${seoRegion ? `, ${seoRegion}` : ''}`;
        return (
          <InternalLink
            variant="textPrimary"
            className={`bg-sea-foam flex h-min w-max items-center rounded-lg p-2 ${isHidden ? 'hidden peer-checked:flex' : ''}`}
            to={getFishingWaterUrl(fishingWaterId, fishingWaterName)}
            key={`SEOWaterLink-${fishingWaterId}`}
          >
            <Text variant="sm" className="mb-0">
              {waterName}
            </Text>
            <ArrowRightIcon className="ml-2" size={14} />
          </InternalLink>
        );
      })}
      <label
        htmlFor="SEOWaterLink-checkbox"
        className="text-deep-sea flex w-full cursor-pointer items-center justify-center py-3 peer-checked:hidden sm:absolute sm:right-0 sm:w-auto sm:py-0"
      >
        <ChevronDownIcon />
        <span className="sr-only">Show more</span>
      </label>
      <label
        htmlFor="SEOWaterLink-checkbox"
        className="text-deep-sea hidden w-full cursor-pointer items-center justify-center py-3 peer-checked:flex sm:absolute sm:right-0 sm:w-auto sm:py-0"
      >
        <ChevronUpIcon />
        <span className="sr-only">Show less</span>
      </label>
    </div>
  );
};
